import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PROFILE_CATEGORY } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'profile-category-selector',
  templateUrl: './profile-category-selector.component.html',
  styleUrl: './profile-category-selector.component.scss',
  standalone: false,
})
export class ProfileCategorySelectorComponent {
  @Input() selectedCategory: string;
  @Output() categoryChange: EventEmitter<string> = new EventEmitter();
  PROFILE_CATEGORY = PROFILE_CATEGORY;

  categoryChangeHandler() {
    this.categoryChange.emit(this.selectedCategory);
  }
}
